import actions from './actions'
import getters from './getters'
import mutations from './mutations'


const state = {
  measurementTypesInfo: [
    { id: 1, measurementGroupId: 2, slug: 'bloodPressure', iconName: 'blood_pressure' },
    { id: 2, measurementGroupId: 3, slug: 'temperature', iconName: 'temperature' },
    { id: 3, measurementGroupId: 4, slug: 'glucose', iconName: 'glucose' },
    { id: 4, measurementGroupId: 5, slug: 'bodyComposition', iconName: 'body_composition' },
    { id: 5, measurementGroupId: 11, slug: 'spirometry', iconName: 'spirometry' },
    { id: 6, measurementGroupId: 18, slug: 'oximetry', iconName: 'oximetry' },
    { id: 7, measurementGroupId: 20, slug: 'mapa24', iconName: 'mapa24' },
    { id: 8, measurementGroupId: 6000, slug: 'frailtyPhenotype', iconName: 'frailty_phenotype' },
    { id: 9, measurementGroupId: 6001, slug: 'sarcopenia', iconName: 'sarcopenia' },
    { id: 10, measurementGroupId: 9000, slug: 'audiology', iconName: 'audiology' },
    { id: 11, measurementGroupId: 9050, slug: 'optometry', iconName: 'optometry' },
    { id: 12, measurementGroupId: 10000, slug: 'cholesterol', iconName: 'cholesterol' },
    { id: 13, measurementGroupId: 21, slug: 'bodyCircumference', iconName: 'body_circumference' },
    { id: 14, measurementGroupId: 1014, slug: 'checkupAnamnese', iconName: 'checkup_anamnese' },
    { id: 15, measurementGroupId: 22, slug: 'copd', iconName: 'copd' },
    { id: 16, measurementGroupId: 24, slug: 'urinary', iconName: 'urinary' },
    { id: 17, measurementGroupId: 25, slug: 'advancedGlucose', iconName: 'advanced_glucose' },
    { id: 18, measurementGroupId: 26, slug: 'blood', iconName: 'blood' },
    { id: 19, measurementGroupId: 27, slug: 'redox', iconName: 'redox' },
    { id: 20, measurementGroupId: 29, slug: 'liver', iconName: 'liver' },
    { id: 21, measurementGroupId: 23, slug: 'biosigns', iconName: 'biosigns' },
    { id: 22, measurementGroupId: 7, slug: 'ecg', iconName: 'ecg'}

  ],
  measurementCharts: [
    {
      "id": 1,
      "code": "BP",
      "description": "Blood Pressure",
      "chart_type": 1,
      "m_group": 2,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://normas.dgs.min-saude.pt/wp-content/uploads/2019/09/hipertensao-arterial_definicao-e-classificacao.pdf",
      "visible_link": "https://normas.dgs.min-saude.pt",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 5,
      "code": "TEMP",
      "description": "Temperature",
      "chart_type": 1,
      "m_group": 3,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://normas.dgs.min-saude.pt",
      "visible_link": "https://normas.dgs.min-saude.pt",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 10,
      "code": "GLICEMIA",
      "description": "Glicemia",
      "chart_type": 1,
      "m_group": 4,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://alimentacaosaudavel.dgs.pt/activeapp2020/wp-content/uploads/2015/10/Processo-Assistencial-Integrado-na-Diabetes-Mellitus-tipo-2-DGS-2013.pdf",
      "visible_link": "https://normas.dgs.min-saude.pt",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 15,
      "code": "BC_IMC",
      "description": "Body Composition IMC",
      "chart_type": 1,
      "m_group": 5,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://alimentacaosaudavel.dgs.pt/activeapp2020/wp-content/uploads/2020/01/Processo-assistencial-integrado-da-pre\u0301-obesidade-no-adulto.pdf",
      "visible_link": "https://alimentacaosaudavel.dgs.pt",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 16,
      "code": "BC_FAT",
      "description": "Body Composition fat mass",
      "chart_type": 1,
      "m_group": 5,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://normas.dgs.min-saude.pt",
      "visible_link": "https://normas.dgs.min-saude.pt",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 20,
      "code": "SPIRO",
      "description": "Spirometry",
      "chart_type": 1,
      "m_group": 11,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://goldcopd.org/2024-gold-report/",
      "visible_link": "https://goldcopd.org/",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 25,
      "code": "OXY",
      "description": "Oximetry",
      "chart_type": 1,
      "m_group": 18,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://normas.dgs.min-saude.pt",
      "visible_link": "https://normas.dgs.min-saude.pt",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 30,
      "code": "FRAILTY",
      "description": "Frailty",
      "chart_type": 1,
      "m_group": 6000,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3028599/",
      "visible_link": "https://www.ncbi.nlm.nih.gov",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 35,
      "code": "SARCO",
      "description": "Sarcopenia",
      "chart_type": 1,
      "m_group": 6001,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6322506/",
      "visible_link": "https://www.ncbi.nlm.nih.gov",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 40,
      "code": "AUDIOLOGY",
      "description": "Audiology",
      "chart_type": 1,
      "m_group": 9000,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://www.who.int/teams/noncommunicable-diseases/sensory-functions-disability-and-rehabilitation/highlighting-priorities-for-ear-and-hearing-care",
      "visible_link": "https://www.who.int",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 50,
      "code": "CHOLEST",
      "description": "Cholesterol",
      "chart_type": 1,
      "m_group": 10000,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://normas.dgs.min-saude.pt/wp-content/uploads/2019/09/abordagem-terapeutica-das-dislipidemias-no-adulto.pdf",
      "visible_link": "https://normas.dgs.min-saude.pt",
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 111,
      "code": "VISION",
      "description": "Vision",
      "chart_type": 1,
      "m_group": 9050,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 1
    },
    {
      "id": 113,
      "code": "COPD_STAGES",
      "description": "Chronic Obstructive Pulmonary Disease Satges",
      "chart_type": 1,
      "m_group": 22,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": "https://goldcopd.org/2024-gold-report/",
      "visible_link": "https://goldcopd.org/",
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 114,
      "code": "BIOSIGNS",
      "description": "Biosigns",
      "chart_type": 1,
      "m_group": 23,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 115,
      "code": "URINE_UI",
      "description": "Urinary Infection",
      "chart_type": 1,
      "m_group": 24,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 116,
      "code": "URINE_DIAB",
      "description": "Decompensated diabetes",
      "chart_type": 1,
      "m_group": 24,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 117,
      "code": "URINE_RC",
      "description": "Renal calculi",
      "chart_type": 1,
      "m_group": 24,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 118,
      "code": "URINE_RD",
      "description": "Renal diseases",
      "chart_type": 1,
      "m_group": 24,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 119,
      "code": "URINE_HD",
      "description": "Hepatic diseases",
      "chart_type": 1,
      "m_group": 24,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 120,
      "code": "BIOCH_GLU_ADV",
      "description": "Advanced Glucose",
      "chart_type": 1,
      "m_group": 25,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 121,
      "code": "BIOCH_BLOOD",
      "description": "Biochemical Blood",
      "chart_type": 1,
      "m_group": 26,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 122,
      "code": "BIOCH_REDOX",
      "description": "Biochemical Redox",
      "chart_type": 1,
      "m_group": 27,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    },
    {
      "id": 124,
      "code": "BIOCH_LACTIC_LIVER",
      "description": "Biochemical Liver",
      "chart_type": 1,
      "m_group": 29,
      "country_call_code": 351,
      "is_default": 1,
      "scientific_support_link": NaN,
      "visible_link": NaN,
      "country_alpha2code": "PT",
      "isShwonChartResult": 0
    }
  ]

}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
